import { http } from "@/config/httpCommon";

export default {
    state: {
        designCategories: [],
        designCategory: {}
    },
    mutations: {
        SET_DESIGN_CATEGORIES(state, payload) {
            state.designCategories = payload;
        },
        SET_DESIGN_CATEGORY(state, payload) {
            state.designCategory = payload;
        }
    },
    actions: {
        async getDesignCategories({ commit }) {
            try {
                let res = await http.get(`/design-categories`);
                commit('SET_DESIGN_CATEGORIES', res.data.data);
                return res;
            } catch (error) {
                return error.response;
            }
        },
        async createDesignCategory({ commit }, payload) {
            try {
                let res = await http.post(`/design-categories`, { category_name: payload });
                commit('SET_DESIGN_CATEGORIES', res.data.data);
                return res;
            } catch (error) {
                return error.response;
            }
        },
        async editDesignCategory({ commit }, payload) {
            try {
                let res = await http.put(`/design-categories/${payload.category_id}`, { category_name: payload.category_name, category_id: payload.category_id });
                commit('SET_DESIGN_CATEGORIES', res.data.data);
                return res;
            } catch (error) {
                return error.response;
            }
        },
        async deleteDesignCategory({ commit }, payload) {
            try {
                console.log('payload', payload);
                let res = await http.delete(`/design-categories/${payload.category_id}`);
                commit('SET_DESIGN_CATEGORIES', res.data.data);
                return res;
            } catch (error) {
                return error.response;
            }
        },
        async getDesignCategory({ commit }, payload) {
            try {
                let res = await http.get(`/design-categories`, payload);
                commit('SET_DESIGN_CATEGORY', res.data.data);
                return res;
            } catch (error) {
                return error.response;
            }
        },
        async assignCategoryToDesignFile({ commit }, payload) {
            try {
                let url = `design-categories/assign-to-design-file`;
                let res = await http.post(url, payload);
                return res;
            } catch (error) {
                return error.response;
            }
        }
    }
}